import { createFileRoute, redirect } from '@tanstack/react-router';
import { api } from '@/lib/api';
import { AppShell } from '@/components/AppShell';

export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context }) => {
    const { user } = await context.queryClient.fetchQuery({
      queryKey: ['session'],
      queryFn: () => api.me().catch(() => ({ user: null })),
    });
    if (!user) {
      throw redirect({ to: '/login', search: { error: undefined, email: undefined } });
    }
    return { user };
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  const { user } = Route.useRouteContext();
  return <AppShell user={user} />;
}
